<p>base-dynamic-view works!</p>
